import { z } from "zod";

// Variation Option Schema
const variationOptionSchema = z.object({
  value: z.string().min(1, "Option value is required"),
  price: z.number().nonnegative("Price must be 0 or greater"),
  stock: z
    .number()
    .int("Stock must be an integer")
    .nonnegative("Stock must be 0 or greater"),
});

export const variationSchema = z.object({
  name: z.string().min(1, "Variation name is required"), // e.g. Size, Color
  options: z
    .array(variationOptionSchema)
    .min(1, "At least one option required"),
});

export const shippingInfoSchema = z.object({
  destination: z.string().min(1, "Destination required"),
  cost: z.number().nonnegative("Cost must be 0 or greater"),
  estimatedDays: z.string().min(1, "Estimated days required"),
});

export const productSchema = z.object({
  title: z.string().min(3, "Title must be at least 3 characters"),
  content: z
    .string()
    .min(10, "Content/description must be at least 10 characters"),

  on_price: z.number().positive("On price must be greater than 0"),
  off_price: z.number().positive("Off price must be greater than 0"),
  original_price: z.number().positive("Original price must be greater than 0"),

  discount: z
    .number()
    .min(0, "Discount must be 0 or greater")
    .max(100, "Discount cannot exceed 100")
    .optional(),

  categoryId: z.number(),
  SubcategoryId: z.number().optional(),

  stock: z.number().int().nonnegative("Stock must be 0 or greater"),

  warehouse: z.string().min(3, "Warehouse is required"),

  images: z
    .array(
      z
        .instanceof(File)
        .refine(
          (file) =>
            file.size > 0 &&
            (file.type.startsWith("image/") || file.type.startsWith("video/")),
          {
            message: "Each file must be a valid image or video",
          }
        )
    )
    .refine((files) => files.some((file) => file.type.startsWith("image/")), {
      message: "At least one file must be an image",
    }),

  shippingInfo: z.array(shippingInfoSchema).optional(),

  shortdes: z.string().min(1, "Short description is required"),

  tags: z
    .array(z.string().min(1))
    .max(3, "You can select a maximum of 3 tags")
    .optional(),

  variations: z.array(variationSchema).optional(),
});
